<ngx-loading-bar id="loading-bar" [height]="'7px'" [color]="'#28a745'" [diameter]="'21px'" [fixed]="true" [includeSpinner]="true"></ngx-loading-bar>
<!-- <ngx-spinner [fullScreen]="false" type="timer" size="medium"></ngx-spinner> [color]="'#009EF7'"-->
<router-outlet></router-outlet>